import { render, staticRenderFns } from "./UnitsSelectbox.vue?vue&type=template&id=0e0a90f4&"
import script from "./UnitsSelectbox.vue?vue&type=script&lang=js&"
export * from "./UnitsSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports